import React from 'react';
import styles from '../styles.module.css';

const ProductBorderImage = ({
    srcImage,
    classNameLogoContainer = styles.logoContainer,
    classNameLogo = styles.logo,
}) => {
    return (
        <div className={classNameLogoContainer}>
            <div className={classNameLogo} style={{ backgroundImage: `url('${srcImage}')` }} />
        </div>
    );
};

export default ProductBorderImage;
